<template>
  <div>
    <slot name="header"></slot>
    <div
      class="membership-template-builder template-two-lesson template-two-container"
    >
      <div class="template-2-breadcrumb" id="top-anchor">
        <slot name="breadcrumb"></slot>
      </div>
      <div class="membership-lesson-container pb-4 relative">
        <div class="w-full flex video-playlist-section">
          <div class="md:w-2/3 rounded-l-lg">
            <slot name="banner-avatar"></slot>
          </div>
          <div class="playlist rounded-r-lg md:w-1/3 overflow-hidden">
            <slot name="lesson-playlist"></slot>
          </div>
        </div>

        <div class="flex md:space-x-5 py-5 lesson-canvas-section">
          <!-- sidebar Left Positon  -->
          <div
            v-if="courseSettings.sidebar_position == 2"
            class="h-screen md:w-4/12 w-full space-y-5 flex flex-col md:mt-0 mt-5 pb-6 template-two-sidebar"
            :class="
              courseSettings.is_outline_sticky == 1 ? 'sidebar-box sticky' : ''
            "
          >
            <slot name="course-instructor"></slot>
            <div
              class="shadow-lg progress-bar-t2-sidebar btn-radius inter-font-regular"
            >
              <slot
                v-if="courseSettings.show_progressbar == 1"
                name="progress-bar"
              ></slot>
            </div>
            <slot name="download-section"></slot>
          </div>
          <div class="w-full md:w-8/12 rounded-lg">
            <div class="lesson-canvas-section-inner">
              <slot name="post-canvas"></slot>
            </div>
            <div class="flex md:space-x-5 pb-7">
              <div class="w-full rounded-lg">
                <slot
                  v-if="courseSettings.show_progressbar == 1"
                  name="mark-as-complete"
                ></slot>
              </div>
            </div>
          </div>
          <!-- sidebar Right Positon  -->
          <div
            v-if="courseSettings.sidebar_position == 1"
            class="h-screen md:w-4/12 w-full space-y-5 flex flex-col md:mt-0 mt-5 pb-6 template-two-sidebar overflow-hidden"
            :class="
              courseSettings.is_outline_sticky == 1 ? 'sidebar-box sticky' : ''
            "
          >
            <slot name="course-instructor"></slot>
            <div
              class="shadow-lg progress-bar-t2-sidebar btn-radius inter-font-regular"
            >
              <slot
                v-if="courseSettings.show_progressbar == 1"
                name="progress-bar"
              ></slot>
            </div>
            <slot name="download-section"></slot>
          </div>
        </div>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>
<script>
export default {
  name: 'PostMarkup',
  data() {
    return {};
  },
  props: {
    courseSettings: {},
  },
};
</script>
<style lang="scss">
.template-two-lesson {
  .template-2-breadcrumb {
    padding-top: 26px;
    .membership-layout-container {
      padding-left: 0px;
    }
  }
  .download-section {
    a {
      position: relative;
      &:after {
        content: '';
        background: url('../../../../../assets/images/icons/pdf-icon.png');
        background-size: 14px 18px !important;
        width: 14px;
        position: absolute;
        height: 18px;
        left: 0px;
        top: 0px;
        bottom: 0px;
        margin: auto;
      }
    }
  }
  .next-arrow {
    position: relative;
    &:after {
      right: 10px;
      background-color: #fff;
      width: 22px;
      height: 16px;
      pointer-events: none;
    }
  }
  .membership-content-section {
    padding-left: 3em;
    padding-right: 3em;
  }

  .video-playlist-section {
    .featured-section {
      img {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        background-color: #80808036;
      }
    }

    .playlist {
      height: 469px;
      width: 400px;
      box-shadow: 0px 0px 12px 4px #0000001c;
      //  padding-right: 4px;
      .custom-scrollbars {
        height: 382px;
        overflow-y: auto;
      }
    }
    .custom-banner-image-overlay {
      position: absolute;
      bottom: 14px;
      right: 100px;
      z-index: 11;
    }
    .md\:w-2\/3 {
      width: 700px;
    }
  }
  .video-custom-dropdown {
    bottom: 0px;
  }
  .main-banner-image {
    display: none;
  }
  .lesson-canvas-section {
    .rounded-lg {
      border-radius: 10px;
    }
    .lesson-canvas-section-inner {
      .space-y-4 > :not([hidden]) ~ :not([hidden]) {
        margin: 0px;
      }
      .section-wrapper {
        margin-bottom: 20px;
      }
    }
  }
}

//css for lesson tablet
.tablet-template {
  .template-two-lesson {
    .lesson-canvas-section {
      flex-direction: column;
      padding-top: 15px;
      .md\:w-8\/12 {
        width: 400px;
        order: 1;
      }
      .md\:w-4\/12 {
        width: 400px;
        order: 0;
        margin-left: 0px;
      }
      .template-two-sidebar {
        order: 1;
      }
      .pb-7 {
        padding-bottom: 0px;
        margin-bottom: 20px;
      }
    }
    .prev-lesson {
      width: 75%;
      .icon {
        margin-left: -7px;
      }
    }
    .next-lesson {
      width: 27%;
      text-align: initial;
      margin-left: 0px;
      .icon {
        margin-left: -3px;
      }
    }
  }
  .video-playlist-section {
    .rounded-l-lg {
      width: 400px;
      height: 250px;
      border-radius: 10px;
      .featured-section {
        border-radius: 8px;
        height: 250px !important;
        img,
        iframe {
          border-radius: 8px;
        }
      }
    }
    .playlist {
      width: 313px;
      margin-left: 14px;
      position: absolute;
      height: calc(100% - 40px);
      right: 0px;
      top: 0px;
      border-radius: 8px;
      //overflow-y: ;
      .custom-scrollbars {
        min-height: 382px;
        height: 100%;
      }
      .rounded-r-lg {
        border-radius: 10px;
      }
    }
  }
}

//css for lesson mobile
.mobile-template {
  .template-two-lesson {
    .lesson-canvas-section {
      flex-direction: column;
      padding-top: 15px;
      .md\:w-8\/12 {
        width: 100%;
        order: 1;
      }
      .md\:w-4\/12 {
        width: 100%;
        order: 0;
        margin-left: 0px;
      }
      .template-two-sidebar {
        order: 1;
      }
      .pb-7 {
        padding-bottom: 17px;
      }
    }
    .prev-lesson {
      width: 72%;
      .icon {
        margin-left: -7px;
      }
    }
    .next-lesson {
      width: 31%;
      text-align: initial;
      margin-left: 0px;
      .icon {
        margin-left: -1px;
      }
    }
    .video-playlist-section {
      flex-direction: column;
      margin-top: 10px;
      .rounded-l-lg {
        width: 100%;
        height: 250px;
        border-radius: 10px;
        .featured-section {
          border-radius: 8px;
          height: 250px !important;
          img,
          iframe {
            border-radius: 8px;
          }
        }
      }
      .playlist {
        width: 100%;
        margin-left: 0px;
        border-radius: 8px;
        overflow-y: auto;
        margin-top: 15px;
        height: 100%;
      }
    }
  }
}

.sidebar-box.sticky {
  top: 20px;
}
@media only screen and (max-width: 992px) {
  .template-two-lesson {
    .video-playlist-section {
      .md\:w-2\/3 {
        width: 60%;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .template-two-lesson {
    .lesson-canvas-section {
      flex-direction: column;
      padding-top: 15px;
      .md\:w-8\/12 {
        width: 100%;
        order: 1;
      }
      .md\:w-4\/12 {
        width: 100%;
        order: 0;
        margin-left: 0px;
      }
      .template-two-sidebar {
        order: 1;
      }
      .pb-7 {
        padding-bottom: 17px;
      }
    }
    .prev-lesson {
      width: 72%;
      .icon {
        margin-left: -7px;
      }
    }
    .next-lesson {
      width: 34%;
      text-align: initial;
      margin-left: 0px;
      .icon {
        margin-left: -1px;
      }
    }
    .video-playlist-section {
      flex-direction: column;
      margin-top: 10px;
      .rounded-l-lg {
        width: 100%;
        height: 250px;
        border-radius: 10px;
        .featured-section {
          border-radius: 8px;
          height: 250px !important;
          img,
          iframe {
            border-radius: 8px;
          }
        }
      }
      .playlist {
        width: 100%;
        margin-left: 0px;
        border-radius: 8px;
        overflow-y: auto;
        margin-top: 15px;
        height: 100%;
      }
    }
  }
}
</style>